// Brands featured on thsnow.in (Shop By Brands) plus core electrical/plumbing names.
const BRANDS = [
    "Surya",
    "North West by Wipro",
    "Supreme",
    "Jaguar",
    "Anchor",
    "ABB",
    "Ledvance",
    "Crabtree",
    "Hindware",
    "Taparia",
    "Bosch",
    "Havells",
    "Finolex",
    "Polycab",
    "Legrand",
    "Astral",
];

export default function LogoStrip() {
    return (
        <section
            data-testid="logo-strip"
            className="bg-charcoal-900 border-y border-white/5 py-6 overflow-hidden"
        >
            <div className="relative">
                <div className="flex gap-14 animate-marquee whitespace-nowrap">
                    {[...BRANDS, ...BRANDS].map((b, i) => (
                        <span
                            key={i}
                            className="font-display font-extrabold text-xl md:text-2xl text-white/40 hover:text-white/80 transition-colors uppercase tracking-tight"
                        >
                            {b}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}
